import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

console.log('[AUTH] REACT_APP_BACKEND_URL =', process.env.REACT_APP_BACKEND_URL);
console.log('[AUTH] API_URL =', API_URL);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      console.log('[AUTH] Token trovato in localStorage, recupero utente...');
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      console.log('[AUTH] Nessun token, utente non autenticato');
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      console.log('[AUTH] GET', `${API_URL}/auth/me`);
      const response = await axios.get(`${API_URL}/auth/me`);
      console.log('[AUTH] Utente recuperato:', response.data);
      setUser(response.data);
    } catch (error) {
      console.error('[AUTH] Errore fetchUser:', error.message);
      console.error('[AUTH] Status:', error.response?.status);
      console.error('[AUTH] Detail:', error.response?.data);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    console.log('[AUTH] Login attempt:', email);
    console.log('[AUTH] POST', `${API_URL}/auth/login`);
    try {
      const response = await axios.post(`${API_URL}/auth/login`, { email, password });
      const { access_token, user: userData } = response.data;
      console.log('[AUTH] Login OK, utente:', userData);
      localStorage.setItem('token', access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
      setToken(access_token);
      setUser(userData);
      return userData;
    } catch (error) {
      console.error('[AUTH] Login FALLITO:', error.message);
      console.error('[AUTH] Status:', error.response?.status);
      console.error('[AUTH] Detail:', error.response?.data);
      throw error;
    }
  };

  const register = async (userData) => {
    const response = await axios.post(`${API_URL}/auth/register`, userData);
    const { access_token, user: newUser } = response.data;
    localStorage.setItem('token', access_token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setToken(access_token);
    setUser(newUser);
    return newUser;
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setUser(null);
  };

  const isAdmin = () => user?.ruolo === 'admin';

  const hasPermission = (section) => {
    if (!user) return false;
    if (user.ruolo === 'admin') return true;
    if (!user.permissions || user.permissions.length === 0) return true;
    return user.permissions.includes(section);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, isAdmin, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
